export default function initLanguageSwitch() {
  const isLocalStorageAvailable = () => {
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      return true;
    } catch(e) {
      return false;
    }
  }


  $('#lang-switch').on('change', function () {
    $('.form-language .region').addClass('d-none');
    $('.form-language .region[data-group=\'' + this.value + '\']').removeClass('d-none');
  });

  $('[name=\'region-switch\']').on('change', function () {
    $(this).parent().addClass('loading');
    window.location = this.value;
    if (isLocalStorageAvailable()) {
      localStorage.setItem('lastSiteVisited', this.dataset.site);
    }
  });

  $('[name=\'region-switch\']:checked').each((index, element) => {
    const url = element.value;
    const sameSites = $(`[name="region-switch"][value="${url}"]`);
    sameSites.each((index, site) => {
      if (element !== site) {
        const siteName = site.dataset.site;
        const lastSiteVisited = isLocalStorageAvailable()
          ? window.localStorage.getItem('lastSiteVisited')
          : '';
        if (siteName === lastSiteVisited) {
          site.checked = true;
        }
      }
    });
  });
}
